import { useMedia } from "@next-platform/client-common-spicy-ui";
import { useCallback } from "react";

import { TAGS_FILTER_LOCAL_STORAGE_KEY } from "@/constants";
import { typedLocalStorageService } from "@/utils/localStorageRe";

import type { SearchTagFilterTriggerProps } from "./types";

type UseSearchFilterPanelToggleParams = Pick<SearchTagFilterTriggerProps, "tagListMinimized" | "setTagListMinimized" | "setTagsDrawer">;

const useSearchFilterPanelToggle = ({ tagListMinimized, setTagListMinimized, setTagsDrawer }: UseSearchFilterPanelToggleParams) => {
  const { isDesktop } = useMedia();

  return useCallback(() => {
    if (isDesktop) {
      setTagListMinimized(!tagListMinimized);
      typedLocalStorageService.setItem(TAGS_FILTER_LOCAL_STORAGE_KEY, String(!tagListMinimized));
      return;
    }
    setTagsDrawer((previousIsVisible) => !previousIsVisible);
  }, [isDesktop, setTagListMinimized, setTagsDrawer, tagListMinimized]);
};

export default useSearchFilterPanelToggle;
